<template>
  <div class="">
    <div class="row gx-3">
      <div class="col-6">
        <label for="date_picker" class="form-label">{{ $t('icsearch_kiedy') }}</label>
        <div class="icpkp-datepicker">
          <ic-date-picker v-model="wartosc" format="YYYY-MM-DD" type="date" id='date_picker' name='date'
            :hideControls="true" title="" :endDate="endDateDynamic"></ic-date-picker>
        </div>
      </div>
      <div class="col-6">
        <label for="ic-seek-time" class="form-label">{{ $t('icsearch_godzina') }}</label>
        <div class="input-group time-picker">
          <input type="text" name="time" :value="formatujCzas()" class="jsTimepickerItem form-control clock-icon"
            id="ic-seek-time" :aria-label="$t('icsearch_aria_godzina')">
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import IcDatePicker from "@/components/ic-common/form/controls/DatePicker.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment";

export default {
  name: 'date-time',
  props: {
    time: String,
    date: String,
    endDate: {
      type: String,
      default: moment()
        .add(2, "month")
        .format("YYYY-MM-DD")
    }
  },
  components: {
    // DatePicker,
    IcDatePicker,
  },
  data() {
    return {
      open: false,
      wartosc: this.formatujDate(),
      endDateDynamic: this.endDate,
      watchInterval: null

    }
  },
  methods: {
    hide() {
      this.open = false
    },
    formatujCzas() {
      if (this.time) return this.time;
      var time = new Date();
      return ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2);
    },
    formatujDate() {
      if (this.date) {
        var dateString = this.date;
        var subs = dateString.split("-");

        var date = new Date(subs[0], subs[1] - 1, subs[2]);
      } else var date = new Date();

      return date;

    },
    aktualizujEndDateZeStid() {
      const hiddenInput = document.querySelector('#stid-0')
      const hiddenInput2 = document.querySelector('#stid-1')
      if (!hiddenInput && !hiddenInput2) return

      const val = hiddenInput.value
      const val2 = hiddenInput2.value
      
      if ((val && !val.startsWith('51')) || (val2 && !val2.startsWith('51'))) {
        this.endDateDynamic = moment().add(2, 'month').format('YYYY-MM-DD')
//        console.log('2m')
      } else {
        this.endDateDynamic = moment().add(1, 'month').format('YYYY-MM-DD')
//      console.log('1m')
      }
    }
  },
  mounted() {
    this.aktualizujEndDateZeStid() // pierwszy raz

    this.watchInterval = setInterval(() => {
      this.aktualizujEndDateZeStid()
    }, 500)
  },
  beforeDestroy() {
    clearInterval(this.watchInterval)
  }
}
</script>
<style>
.icpkp-datepicker .input-controls {
  display: none;
}
</style>